import C from "./constants";
import initialState from "./initialState"

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case C.UPDATE_MINIPLAYER_STATUS: {
      return {...state, ...action.payload};
    }
    default: {
      return state;
    }
  }
}
